import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getSites = state => state.sites;

export const getSettingsDispensingSites = createSelector(getSites, sites => get(sites, 'dispensingSites'));



// WEBPACK FOOTER //
// ./src/reducers/sites/selectors.js